<template>
  <section id="add-reception">
    <main style="text-align:left;white-space:normal">
      <!-- * NOT TRW -->
      <div v-if="!auth.isTrw">
        <div class="title">
          <icon icoClass='title-ico' selected='receptions'/>
          {{ editing ? $t('edit_reception') : $t('add_reception') }}
          <button v-if="editing  && canSeeHistory" :title="$t('history')" class="btn-green btn-shipment" @click="showHistoric=true"><i class="fas fa-history"></i></button>
        </div>
        <div class="field" v-if="auth.hasRepeatReception">
          <div class="field" v-if="editing && reception.booked_date">
            <div class="field-half-page" :readonly="editJustNotes || editJustCompNotes || editJustTrucksHours">
              <label>{{ $t('booked_date') }}<span class="mandatory">*</span></label>
              <input type="datetime-local" placeholder="dd/mm/yyyy" v-model="reception.booked_date" :readonly="true" :disabled="read_only"/>
            </div>
            <button class="btn-blue btn-change" :disabled="editJustNotes || editJustCompNotes || editJustTrucksHours || read_only" @click="reception.booked_date=undefined; loadAvailable()">{{ $t('change') }}</button>
          </div>
          <div class="field" v-else>
            <div class="field-half-page" :readonly="editJustNotes || editJustCompNotes || editJustTrucksHours">
              <label>{{ showRepeat ? $t('start_at') : $t('booked_date') }}<span class="mandatory">*</span></label>
              <input type="date" placeholder="dd/mm/yyyy" v-model="bookedDate" :readonly="editJustNotes || editJustCompNotes || editJustTrucksHours || read_only" @change="loadAvailable()"/>
            </div>
            <div class="field-half-page">
              <label style="display: inline-block">{{ $t('window') }}</label>
              <div style="display:flex;align-items:center">
                <span class="custom-dropdown">
                  <select v-model="hour" :disabled="editJustNotes || editJustCompNotes || editJustTrucksHours || read_only" style="min-width:8em;width:8em">
                    <option v-for="(hour, index) in availableHours" :key="index" :value="hour" style="text-transform: uppercase">
                      {{ hour }}
                    </option>
                  </select>
                </span>
                <label style="display: inline-block; padding-right:.5em" v-if="!editing">{{ $t('repeat') }}</label>
                <span class="input-height" v-if="canRepeat && !editing" style="padding-right: 2em;">
                  <label class="checkBox" for="showRepeat" @click.capture.stop>
                    <input type="checkbox" id="showRepeat" v-model="showRepeat" />
                    <span class="checkmark" style="top:-.25em;"/>
                  </label>
                </span>
              </div>
            </div>
          </div>
          <r-rule-form v-if="showRepeat" @generate="rruleObj=$event" />
          <div class="field-half-page">
            <label>{{ $t('discharge_date') }}</label>
            <input type="datetime-local" placeholder="dd/mm/yyyy" v-model="reception.action_date" :readonly="editJustNotes || editJustCompNotes"/>
          </div>
        </div>
        <div class=field v-else>
          <div class="field-half-page">
            <label>{{ $t('booked_date') }}<span class="mandatory">*</span></label>
            <input type="datetime-local" placeholder="dd/mm/yyyy" v-model="reception.booked_date" required :readonly="editJustNotes || editJustCompNotes"/>
          </div>
          <div class="field-half-page">
            <label>{{ $t('discharge_date') }}</label>
            <input type="datetime-local" placeholder="dd/mm/yyyy" v-model="reception.action_date" :readonly="editJustNotes || editJustCompNotes"/>
          </div>
        </div>
        <div class="field-half-page">
          <label>{{ $t('delivery_note') }}<span class="mandatory">*</span></label>
          <input type="text" v-model="reception.code" :readonly="editJustNotes || editJustCompNotes"/>
        </div>
        <div class="field-half-page">
          <label>{{ $t('origin') }}</label>
          <search-select
            inputStyle="box-sizing: border-box"
            divStyle="text-transform: uppercase;width: 100%; box-sizing: border-box; display: inline-block"
            url="client"
            field="description"
            :allowFreeText="true"
            @data="reception.destination = $event"
            :source="reception.destination"
          />
        </div>
        <div class="field">
          <label>
            {{ $t('client') }}<span class="mandatory">*</span>
            <button class="btn-blue" @click="openClientDetail" v-if="canCreateMasters">{{ $t("add_client") }}</button>
            <button class="btn-green" @click="openClientDetail(reception.client)" v-if="reception.client && canCreateMasters">{{ $t("edit_client") }}</button>
          </label>
          <search-select
            inputStyle="box-sizing: border-box"
            divStyle="text-transform: uppercase;width: 100%; box-sizing: border-box; display: inline-block"
            url="client"
            field="description"
            @data="reception.client=$event"
            :source="reception.client"
          />
        </div>
        <div class="field">
          <label>{{ $t('c_notes') }}</label>
          <textarea @keypress.enter.prevent v-model="reception.client_notes" :readonly="editJustCompNotes"/>
        </div>
        <div class="field">
          <label>{{ $t('k_notes') }}</label>
          <textarea @keypress.enter.prevent v-model="reception.company_notes" :readonly="editJustNotes"/>
        </div>
        <div class="field">
          <label>{{ $t('dock') }}</label>
          <textarea  @keypress.enter.prevent v-model="reception.dock" :readonly="editJustNotes"/>
        </div>
        <div class="field">
          <div class="field-half-page">
            <label>{{ $t('road') }}</label>
            <input type="text" placeholder="0" v-model="reception.road_number" :readonly="editJustNotes || editJustCompNotes"/>
          </div>
          <div class="field-half-page">
            <label>{{ $t('status') }}</label>
            <span class="custom-dropdown">
              <select v-model="reception.status" :disabled="editJustNotes || editJustCompNotes">
                <option v-for="st in status" :key="st.id" :value="st">
                  {{ $t(st.description) }}
                </option>
              </select>
            </span>
          </div>
        </div>
        <div class="field">
          <div class="field-half-page">
            <label>{{ $t('shared_id') }}</label>
            <input type="text" v-model="reception.shared_id" :readonly="editJustNotes || editJustCompNotes || editJustTrucksHours || read_only" :disabled="read_only"/>
          </div>
        </div>
        <div class="field-half-page">
          <label>{{ $t('groupage') }}</label>
          <span class="input-height">
            <label class="checkBox" for="groupage" @click.capture.stop>
              <input type="checkbox" id="groupage" v-model="reception.groupage"/>
              <span class="checkmark" />
            </label>
          </span>
        </div>
        <div class="field-half-page">
          <label>{{ $t('own_truck') }}</label>
          <span class="input-height">
            <label class="checkBox" for="own_truck" @click.capture.stop>
              <input type="checkbox" id="own_truck" v-model="reception.own_truck"/>
              <span class="checkmark" />
            </label>
          </span>
        </div>
        <div class="field">
          <label>{{ $t('truck') }}
            <button class="btn-blue" @click="openTruckDetail()" v-if="canAddTruck">{{ $t("add_truck") }}</button>
            <button class="btn-green" @click="openTruckDetail(reception.shipper)" v-if="canAddTruck && reception.shipper">{{ $t("edit_truck") }}</button>
          </label>
          <search-select
            inputStyle="box-sizing: border-box"
            divStyle="width: 100%; box-sizing: border-box; display: inline-block"
            url="shipper/available"
            field="plate"
            format="{name} ({plate})"
            :source="reception.shipper"
            @data="reception.shipper=$event"
            :disabled="editJustNotes || editJustCompNotes || editJustTrucksHours || read_only"
          />
        </div>
        <div class="field-half-page">
          <label>{{ $t('packages') }}</label>
          <input type="number" min="0" v-model="reception.packages" :readonly="editJustNotes || editJustCompNotes"/>
        </div>
        <div class="field-half-page">
          <label>{{ $t('weight') }}</label>
          <input type="number" v-model="reception.weight"/>
        </div>
        <button class="btn-green" @click="save()" :disabled="saving">{{ $t('save') }}</button>
        <button class="btn-black" @click="$router.back()">{{ $t('cancel') }}</button>
      </div>
      <!-- * TRW -->
      <div v-else>
        <div class="title">
          <icon icoClass='title-ico' selected='receptions'/>
          {{ editing ? $t('edit_reception') : $t('add_reception') }}
          <button v-if="editing  && canSeeHistory" :title="$t('history')" class="btn-green btn-shipment" @click="showHistoric=true"><i class="fas fa-history"></i></button>
        </div>
        <div class="fields">
          <div class="field">
            <div class="field-half-page">
              <label style="display: inline-block">{{ $t('load_empty') }}</label>
              <span class="input-height">
                <label class="checkBox" for="load_empty" @click.capture.stop>
                  <input type="checkbox" id="load_empty" v-model="reception.load_empty" :disabled="editJustNotes || editJustCompNotes || editJustTrucksHours || read_only" />
                  <span class="checkmark" />
                </label>
              </span>
            </div>
            <div class="field-half-page" v-if="reception.load_empty">
              <label style="display: inline-block">{{ $t('load_type') }}</label>
              <span class="input-height">
                <label class="checkBox" for="load_type" @click.capture.stop>
                  <input type="checkbox" id="load_type" v-model="reception.load_type" :disabled="editJustNotes || editJustCompNotes || editJustTrucksHours || read_only"/>
                  <span class="checkmark" />
                </label>
              </span>
            </div>
          </div>
          <div class="field" v-if="auth.hasRepeatReception">
            <div class="field" v-if="editing && reception.booked_date">
              <div class="field-half-page" :readonly="editJustNotes || editJustCompNotes || editJustTrucksHours">
                <label>{{ $t('booked_date') }}<span class="mandatory">*</span></label>
                <input type="datetime-local" placeholder="dd/mm/yyyy" v-model="reception.booked_date" :readonly="true" :disabled="read_only"/>
              </div>
              <button class="btn-blue btn-change" :disabled="editJustNotes || editJustCompNotes || editJustTrucksHours || read_only" @click="reception.booked_date=undefined; loadAvailable()">{{ $t('change') }}</button>
            </div>
            <div class="field" v-else>
              <div class="field-half-page" :readonly="editJustNotes || editJustCompNotes || editJustTrucksHours">
                <label>{{ showRepeat ? $t('start_at') : $t('booked_date') }}<span class="mandatory">*</span></label>
                <input type="date" placeholder="dd/mm/yyyy" v-model="bookedDate" :readonly="editJustNotes || editJustCompNotes || editJustTrucksHours || read_only" @change="loadAvailable()"/>
              </div>
              <div class="field-half-page">
                <label style="display: inline-block">{{ $t('window') }}</label>
                <div style="display:flex;align-items:center">
                  <span class="custom-dropdown">
                    <select v-model="hour" :disabled="editJustNotes || editJustCompNotes || editJustTrucksHours || read_only" style="min-width:8em;width:8em">
                      <option v-for="(hour, index) in availableHours" :key="index" :value="hour" style="text-transform: uppercase">
                        {{ hour }}
                      </option>
                    </select>
                  </span>
                  <label style="display: inline-block; padding-right:.5em" v-if="!editing">{{ $t('repeat') }}</label>
                  <span class="input-height" v-if="canRepeat && !editing" style="padding-right: 2em;">
                    <label class="checkBox" for="showRepeat" @click.capture.stop>
                      <input type="checkbox" id="showRepeat" v-model="showRepeat" />
                      <span class="checkmark" style="top:-.25em;"/>
                    </label>
                  </span>
                </div>
              </div>
            </div>
            <r-rule-form v-if="showRepeat" @generate="rruleObj=$event" />
            <div class="field-half-page">
              <label>{{ $t('discharge_date') }}</label>
              <input type="datetime-local" placeholder="dd/mm/yyyy" v-model="reception.action_date" :readonly="editJustNotes || editJustCompNotes"/>
            </div>
          </div>
          <div class=field v-else>
            <div class="field-half-page">
              <label>{{ $t('booked_date') }}<span class="mandatory">*</span></label>
              <input type="datetime-local" placeholder="dd/mm/yyyy" v-model="reception.booked_date" required :readonly="editJustNotes || editJustCompNotes"/>
            </div>
            <div class="field-half-page">
              <label>{{ $t('discharge_date') }}</label>
              <input type="datetime-local" placeholder="dd/mm/yyyy" v-model="reception.action_date" :readonly="editJustNotes || editJustCompNotes"/>
            </div>
          </div>
          <div class="field">
            <label v-if="!read_only">
              {{ $t('origin') }}<span class="mandatory">*</span>
              <button class="btn-blue" @click="openClientDetail" v-if="canCreateMasters">{{ $t("add_client") }}</button>
              <button class="btn-green" @click="openClientDetail(reception.client)" v-if="reception.client && canCreateMasters">{{ $t("edit_client") }}</button>
            </label>
            <search-select
              inputStyle="box-sizing: border-box"
              divStyle="text-transform: uppercase;width: 100%; box-sizing: border-box; display: inline-block"
              url="client"
              field="description"
              @data="reception.client=$event"
              :source="reception.client"
              :listdata="auth.userData.clients"
            />
          </div>
          <div v-if="reception.client" class="field">
            <label>{{ $t('origin_notes') }}</label>
            <textarea v-model="reception.client.notes" readonly :disabled="read_only"/>
          </div>
          <div class="field">
            <label v-if="auth.isTrw">{{ $t('c_notes_trw') }}</label>
            <label v-else>{{ $t('c_notes') }}</label>
            <textarea @keypress.enter.prevent v-model="reception.client_notes" :readonly="editJustCompNotes || editJustTrucksHours" :disabled="read_only"/>
          </div>
          <div class="field">
            <label v-if="auth.isTrw">{{ $t('k_notes_trw', [$t(companyCode)]) }}</label>
            <label v-else>{{ $t('k_notes') }}</label>
            <textarea @keypress.enter.prevent v-model="reception.company_notes" :readonly="editJustNotes || editJustTrucksHours" :disabled="read_only"/>
          </div>
          <div class="field">
            <label>{{ $t('warehouse') }}</label>
            <textarea  @keypress.enter.prevent v-model="reception.warehouse" :readonly="editJustNotes"/>
          </div>
          <div class="field">
            <label>{{ $t('packages') }}</label>
            <input type="number" min="0" v-model="reception.packages" :readonly="editJustNotes || editJustCompNotes || editJustTrucksHours" :disabled="read_only"/>
          </div>
          <div class="field">
            <div class="field-half-page">
              <label>{{ $t('status') }}</label>
              <span class="custom-dropdown">
                <select v-model="reception.status" :disabled="editJustNotes || editJustCompNotes || read_only">
                  <option v-for="st in status" :key="st.id" :value="st">
                    {{ $t(st.description) }}
                  </option>
                </select>
              </span>
            </div>
            <div class="field-half-page">
              <label>{{ $t('urgent') }}</label>
              <span class="input-height">
                <label class="checkBox" for="urgent" @click.capture.stop>
                  <input type="checkbox" id="urgent" v-model="reception.urgent" :disabled="editJustNotes || editJustCompNotes || editJustTrucksHours || read_only" />
                  <span class="checkmark" />
                </label>
              </span>
            </div>
          </div>
          <div class="field">
            <div class="field-half-page">
              <label>{{ $t('shared_id') }}</label>
              <input type="text" v-model="reception.shared_id" :readonly="editJustNotes || editJustCompNotes || editJustTrucksHours || read_only" :disabled="read_only"/>
            </div>
          </div>
          <div class="field">
            <label v-if="!read_only">{{ $t('truck') }}
              <button class="btn-blue" v-if="canAddTruck" @click="openTruckDetail()" :disabled="is_zf">{{ $t("add_truck") }}</button>
              <button class="btn-green" v-if="canAddTruck && reception.shipper" @click="openTruckDetail(reception.shipper)" :disabled="is_zf">{{ $t("edit_truck") }}</button>
            </label>
            <label v-else>{{ $t('truck') }}</label>
            <search-select
              inputStyle="box-sizing: border-box"
              divStyle="width: 100%; box-sizing: border-box; display: inline-block"
              url="shipper/available"
              field="plate"
              format="{name} ({plate})"
              :source="reception.shipper"
              @data="reception.shipper=$event"
              :disabled="read_only"
            />
          </div>
          <div class="field packing-list" v-if="auth.hasPackingList">
            <div class="packing-list-title">
              <label>{{ $t('packing_list') }}</label>
              <button class="btn-blue" @click="showAdd=true; packs={}" v-if="!read_only">{{ $t('add_packing') }}</button>
            </div>
            <table class="custom-table" v-if="packingList && packingList.length > 0">
              <thead>
                <tr>
                  <th>{{ $t('reference') }}</th>
                  <th style="min-width: 25em;">{{ $t('material') }}</th>
                  <th>{{ $t('number_packages') }}</th>
                  <th v-if="!read_only">{{ $t('actions') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="pack of packingList" :key="pack.id">
                  <td>{{ pack.material.reference }}</td>
                  <td>{{ pack.material.name }}</td>
                  <td>{{ pack.number_packages }}</td>
                  <td class="actions" v-if="!read_only">
                    <a :title="$t('edit')" @click="packs=pack; materialSearch=pack.material; showEdit=true">
                      <misc-icon icoClass='title-ico' selected='edit'/>
                    </a>
                    <a :title="$t('delete')" @click="obj=pack; showDelete=true">
                      <misc-icon icoClass='title-ico' selected='delete' :title="$t('delete')"/>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="margin:.5em;text-align: center" v-if="editing">
            <button class="btn-blue" @click="openAttachments(reception)">{{ $t('files') }}</button>
            <button class="btn-black" @click="getQR(); showQR=true">{{ $t('qr_code') }}</button>
          </div>
          <button class="btn-green" @click="save()" :disabled="saving">{{ $t('save') }}</button>
          <button class="btn-black" @click="$router.back()">{{ $t('cancel') }}</button>
        </div>
      </div>

      <!-- * SHARED -->
      <!-- Modals -->

      <modal v-if="showClient">
        <div slot="body">
          <add-client :id="clientId" @close="showClient=false; clientId=null" @refreshClients="getClients().then(response => { clients = response })" />
        </div>
      </modal>
      <modal v-if="showTruckDetail" :overflows="true">
        <div slot="body">
          <add-truck :id="truckId" @cancel="showTruckDetail=false" @save="handleTruckSave" />
        </div>
      </modal>

      <modal v-if="showDelete">
        <div slot="body" class="delete-modal">
          {{ $t("delete_message") }}
          <div class="buttons">
            <button class="btn-green" @click="deletePack(obj)">
              {{ $t("ok") }}
            </button>
            <button class="btn-black" @click=" showDelete = false;">
              {{ $t("cancel") }}
            </button>
          </div>
        </div>
      </modal>

      <modal v-if="showQR">
        <div slot="body" class="delete-modal">
          <img :src="'data:image/svg;base64,'+ qrString" style="width: 450px; height: 440px; padding:0" />
          <div class="buttons">
            <button class="btn-green" @click="downloadImg('data:image/svg;base64,'+ qrString, 'Reception-'+ reception.code)">
              {{ $t("print_qr") }}
            </button>
            <button class="btn-black" @click=" showQR = false;">
              {{ $t("close") }}
            </button>
          </div>
        </div>
      </modal>

      <modal v-if="showAdd || showEdit">
        <div slot="body">
          <label class="title" v-if="showAdd"><misc-icon icoClass='title-ico' selected='box'/>{{ $t("add_packing") }}</label>
          <label class="title" v-else><misc-icon icoClass='title-ico' selected='box'/>{{ $t("edit_packing") }}</label>
          <div class="fields">
            <div class="field">
              <div class="packing-list-title">
                <label>{{ $t('material') }}</label>
                <button class="btn-blue" @click="showAddMaterial=true">{{ $t('add_material') }}</button>
              </div>
              <search-select
                inputStyle="box-sizing: border-box"
                divStyle="width: 100%; box-sizing: border-box; display: inline-block"
                field="name"
                url="materials/autocomplete_name"
                @data="packs.material=$event"
                :source="packs.material"
              />
            </div>
            <div class="field">
              <label>{{ $t('number_packages') }}</label>
              <input type="number" v-model="packs.number_packages" />
            </div>
            <button class="btn-green" @click="savePackageList()">{{ $t('save') }}</button>
            <button class="btn-black" @click="$emit('cancel'); showAdd=false; showEdit=false">{{ $t('cancel') }}</button>
          </div>
        </div>
      </modal>

      <modal v-if="showAddMaterial">
        <div slot="body">
          <label class="title"><misc-icon icoClass='title-ico' selected='box'/>{{ $t("new_material") }}</label>
          <div class="fields">
            <div class="field">
              <label>{{ $t('reference') }}</label>
              <input type="text" v-model="newMaterial.reference" />
            </div>
            <div class="field">
              <label>{{ $t('name') }}</label>
              <input type="text" v-model="newMaterial.name" />
            </div>
            <button class="btn-green" @click="saveMaterials()">{{ $t('save') }}</button>
            <button class="btn-black" @click="$emit('cancel'); showAddMaterial=false">{{ $t('cancel') }}</button>
          </div>
        </div>
      </modal>

      <modal v-if="showAttachments">
        <div slot="body">
          <attachments :title="object.date" :object="object" :canEdit="!read_only" @close="showAttachments=false" />
        </div>
      </modal>

      <modal v-if="showHistoric">
        <div slot="body">
          <historic :shipment="reception" :code="reception.code" :type="shipmentType" :company="companyCode" :trw="auth.isTrw" @close="showHistoric=false" />
        </div>
      </modal>
      <create-errors-modal v-if="errors.length" :errors="errors" @close="errors=[]"/>
    </main>
  </section>
</template>

<script>
import CreateErrorsModal from './../components/CreateErrorsModal'
import SearchSelect from './../components/SearchSelect'
import SearchInput from './../components/SearchInput'
import Attachments from './../components/Attachments'
import RRuleForm from '../components/RRuleForm'
import Historic from './../components/Historic'
import AddClient from './../components/Client'
import AddTruck from './../components/Truck'
import Modal from './../components/Modal'
import {mapActions, mapState} from 'vuex'
import miscIcon from './../svg/misc'
import icon from './../svg/tabs'
import { RRule } from 'rrule'
import moment from 'moment'

export default {
  name: 'add-rec',
  components: {
    CreateErrorsModal,
    SearchSelect,
    Attachments,
    SearchInput,
    AddClient,
    RRuleForm,
    Historic,
    miscIcon,
    AddTruck,
    Modal,
    icon
  },
  props: {
  },
  created () {
    this.$emit('loading')
    this.getAddReceptionsData()
  },
  mounted () {
  },
  data () {
    return {
      newMaterial: {reference: '', name: ''},
      companyCode: process.env.COMPANY,
      reception: {status: 999},

      editJustTrucksHours: false,
      canAvoidLockdowns: false,
      editJustCompNotes: false,
      canCreateMasters: false,
      showAttachments: false,
      showAddMaterial: false,
      showTruckDetail: false,
      canSeeHistory: false,
      editJustNotes: false,
      showHistoric: false,
      canAddTruck: false,
      showClient: false,
      showDelete: false,
      showRepeat: false,
      canRepeat: false,
      read_only: false,
      showEdit: false,
      editing: false,
      showAdd: false,
      showQR: false,
      saving: false,
      is_zf: false,

      availableHours: [],
      packingList: [],
      materials: [],
      rruleObj: {},
      clients: [],
      status: [],
      trucks: [],
      errors: [],
      packs: {},
      obj: {},

      shipmentType: 'reception',
      truckId: null,
      bookedDate: '',
      qrString: '',
      hour: ''
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  },
  methods: {
    ...mapActions({
      checkPermissions: 'auth/checkPermissions',

      saveReception: 'receptions/save',
      getReception: 'receptions/read',
      getQr: 'receptions/getQR',
      getAvailableDates: 'receptions/availableDates',

      getPackingLists: 'packinglists/list',
      savePackList: 'packinglists/save',
      deletePackingList: 'packinglists/delete',

      saveMaterial: 'materials/save',
      getMaterials: 'materials/list',

      getTrucks: 'trucks/available',

      getClients: 'clients/list',

      getStatus: 'status/list'
    }),
    getQR () {
      this.getQr(this.reception.id).then(response => {
        this.qrString = response.qr
      })
    },
    setRruleStr (rrule) {
      if (this.reception.booked_date) {
        rrule.options.dtstart = this.reception.booked_date + 'Z'
        this.reception.rrule_str = RRule.optionsToString(rrule.options)
      }
    },
    loadAvailable () {
      this.hour = undefined
      this.availableHours = []

      if (moment(this.bookedDate, 'YYYY-MM-DD', true).isValid()) {
        const skip = this.showRepeat || this.canAvoidLockdowns
        this.getAvailableDates({ date: this.bookedDate, skip: skip })
          .then((response) => {
            this.availableHours = response.map(h => {
              const m = moment.parseZone(h)
              return m.isValid() ? m.format('HH:mm') : null
            })
              .filter(Boolean)
              .filter((v, i, arr) => arr.indexOf(v) === i)
              .sort((a, b) => a.localeCompare(b))
          })
      }
    },
    save () {
      this.saving = true

      if (!this.auth.isTrw && !this.reception.code) {
        this.$notify({ group: 'global', type: 'error', duration: 4000, title: 'Warning', text: this.$t('fill_mandatory') })
        this.saving = false
        return
      }

      if (this.auth.hasRepeatReception && this.bookedDate) {
        const bookedDate = moment(this.bookedDate + ' ' + this.hour, 'YYYY-MM-DD HH:mm')
        if (!bookedDate.isValid()) {
          this.$notify({ group: 'global', type: 'error', duration: 4000, title: 'Warning', text: this.$t('invalid_date_time') })
          this.saving = false
          return
        }

        this.reception.booked_date = bookedDate.format('YYYY-MM-DDTHH:mm:ss')
      }

      if (this.reception.action_date) {
        const actionDate = moment(this.reception.action_date)
        if (!actionDate.isValid()) {
          this.reception.action_date = null
        } else {
          this.reception.action_date = actionDate.format('YYYY-MM-DDTHH:mm:ss')
        }
      } else {
        this.reception.action_date = null
      }

      if (this.showRepeat) this.setRruleStr(this.rruleObj)
      else this.reception.rrule_str = undefined

      var reception = JSON.parse(JSON.stringify(this.reception))

      if (reception.client_notes) reception.client_notes = reception.client_notes.replace(/(\r\n|\n|\r)/gm, ' ')
      if (reception.company_notes) reception.company_notes = reception.company_notes.replace(/(\r\n|\n|\r)/gm, ' ')
      if (reception.destination && reception.destination.description) {
        reception.destination = reception.destination.description
      } else {
        reception.destination = ''
      }

      reception.load_empty = reception.load_empty ? 'load' : 'empty'
      reception.load_type = reception.load_empty ? (reception.load_type ? 'full' : 'not_full') : undefined

      if (!reception.id) reception = Object.assign({}, reception, {company: this.auth.company, user: this.auth.userData.user.id})

      if (!reception.client) {
        this.$notify({ group: 'global', type: 'error', duration: 4000, title: 'Warning', text: this.$t('fill_mandatory') })
        this.saving = false
        return
      }

      if (!this.reception.id && this.packingList.length > 0) {
        reception.packing_list = this.packingList.map((x) => {
          return { 'material': x.material.id, 'number_packages': x.number_packages }
        })
      }
      Object.keys(reception).forEach(key => {
        if (reception[key] && reception[key].id) reception[key] = reception[key].id
      })

      if (reception.user && reception.user.user) {
        if (reception.user.user.id) reception.user = reception.user.user.id
        else reception.user = reception.user.user
      }

      this.saveReception(reception)
        .then((response) => {
          if (this.showRepeat && response.length > 0) {
            const errors = response.errors || []
            if (errors.length > 0) {
              this.$notify({ group: 'global', type: 'error', duration: 4000, title: 'Warning', text: 'Some receptions were not created' })
            }
          }
          this.$router.back()
        })
        .finally(() => { this.saving = false })
    },
    saveMaterials () {
      this.newMaterial.company = this.auth.company
      this.saveMaterial(this.newMaterial).then(response => {
        this.$emit('save', response)
        this.newMaterial.reference = ''
        this.newMaterial.name = ''
        this.showAddMaterial = false
      })
    },
    savePackageList () {
      if (this.$route.params.id || this.is_editing) {
        this.packs.material = this.packs.material.id
        this.packs.shipment = this.reception.id
        this.savePackList(this.packs).then(response => {
          this.packingList = []
          this.getPackingLists({shipment: this.$route.params.id}).then(response => { this.packingList = response })
          this.$emit('save', response)
        })
      } else this.packingList.push(this.packs)
      this.showAdd = false
      this.showEdit = false
    },
    deletePack (obj) {
      if (obj.id) {
        this.deletePackingList(obj.id).then(() => {
          this.obj = undefined
          this.packingList = []
          this.showDelete = false
          this.getPackingLists({shipment: this.$route.params.id}).then(response => { this.packingList = response })
        })
      } else {
        this.packingList.pop(obj)
        this.showDelete = false
      }
    },
    downloadImg (source, title) {
      const fileName = title.trim() + '.png'
      const el = document.createElement('a')
      el.setAttribute('href', source)
      el.setAttribute('download', fileName)
      document.body.appendChild(el)
      el.click()
      el.remove()
    },
    checkPlannerZF () {
      if (this.auth.userData && this.auth.userData.roles.some(rol => rol.description === 'Planner ZF')) {
        this.is_zf = true
        this.canAddTruck = false
      }
    },
    formatDate (date, bookedDate) {
      if (bookedDate) {
        this.hour = moment(date).format('HH:mm')
        this.bookedDate = moment(date).format('YYYY-MM-DD')
      }
      return moment(date).format('YYYY-MM-DDTHH:mm:ss')
    },
    openAttachments (reception) {
      this.object = JSON.parse(JSON.stringify(reception))
      this.showAttachments = true
    },
    openTruckDetail (truck) {
      this.truckId = truck ? truck.id : null
      this.showTruckDetail = true
    },
    openClientDetail (client) {
      if (client) this.clientId = client.id
      this.showClient = true
    },
    getUniqueTrucksByPlate (trucks) {
      if (!Array.isArray(trucks)) return trucks
      const truckMap = trucks.reduce((acc, truck) => {
        const existingTruck = acc[truck.plate]
        if (!existingTruck || new Date(truck.register_date) > new Date(existingTruck.register_date)) acc[truck.plate] = truck
        return acc
      }, {})

      return Object.values(truckMap)
    },
    handleTruckSave (truck) {
      this.showTruckDetail = false
      const index = this.trucks.findIndex(t => t.id === truck.id)
      if (index !== -1) {
        this.$set(this.trucks, index, truck)
      } else {
        this.trucks.push(truck)
      }
      this.trucks = this.getUniqueTrucksByPlate(this.trucks)
      this.reception.shipper = this.trucks.find(t => t.id === truck.id) || truck
    },

    // Async methods
    async getPermissions () {
      const permissionResponse = await this.checkPermissions([
        'createMasters',
        'seeHistory',
        'justClientNotes',
        'justCompanyNotes',
        'onlyTruckHours',
        'repeatReceptions',
        'lockdowns',
        'addTruck'
      ])
      this.canCreateMasters = permissionResponse.createMasters
      this.canSeeHistory = permissionResponse.seeHistory
      this.editJustNotes = !permissionResponse.justClientNotes
      this.editJustCompNotes = !permissionResponse.justCompanyNotes
      this.editJustTruckHours = !permissionResponse.onlyTruckHours
      this.canRepeat = permissionResponse.repeatReceptions
      this.canAvoidLockdowns = !permissionResponse.lockdowns
      this.canAddTruck = permissionResponse.addTruck
    },
    async getInitialData () {
      this.status = await this.getStatus('reception')
      this.materials = await this.getMaterials()
      this.clients = this.auth.userData.clients.length > 0 ? await this.getClients({id: this.auth.userData.clients}) : await this.getClients()
    },
    async getEditingData (id) {
      this.editing = true
      this.trucks = await this.getUniqueTrucksByPlate(this.getTrucks({ line: id }))
      if (this.auth.hasPackingList) {
        this.packingList = await this.getPackingLists({ shipment: id })
      }
      this.reception = await this.getReception(id)
      if (typeof this.reception.destination === 'string') {
        this.reception.destination = { description: this.reception.destination }
      }
      if (this.reception.booked_date) this.reception.booked_date = this.formatDate(this.reception.booked_date, this.auth.hasRepeatReception)
      if (this.reception.action_date) this.reception.action_date = this.formatDate(this.reception.action_date, false)
    },
    async getAddReceptionsData () {
      try {
        this.checkPlannerZF()
        if (this.$route.query.read_only) this.read_only = true
        await this.getPermissions()
        await this.getInitialData()
        if (this.$route.params && this.$route.params.id) this.getEditingData(this.$route.params.id)
        else this.trucks = await this.getUniqueTrucksByPlate(this.getTrucks())
      } catch (error) {
        console.error('Error getting reception data:', error)
      } finally {
        this.$emit('loaded')
      }
    }
  }
}
</script>

<style scoped lang="scss">
#add-reception{
  display: table;
  min-width: 50%;
}
input, textarea {
  width: 100%;
  box-sizing: border-box;

}
textarea{
  resize: vertical;
}
.fields {
  padding: 0 3em;
}
.field-half-page {
  display: inline-block;
  width: 49.4%;
  box-sizing: border-box;
}
.btn-shipment {
  float:right;
  font-size:.7em;
  margin-right:.1em;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageAddReception.vue